import { CustomButton } from '@Modules/core/components';
import CustomDataTableInfoBtn from '@Modules/core/components/table/CustomDataTableInfoBtn';
import { Center, Checkbox, Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import ConsultationDatatableRowMeta from "@Modules/interfaceManagement/visaBase2/containers/tableHandlers/fees/outgoing/consultation/ConsultationDatatableRowMeta";

export type TConsultationDatatableData = {
    primaryKey: string | number,
    pan: string,
    sequence: string,
    oneId: string,
    nberOfCommands: string,
    nberOfSendings: string,
    executionDate: string,
    endDate: string,
    status: string,
    active: boolean,
    //
    [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleDetails: (row: any) => void,
};

const columnHelper = createColumnHelper<TConsultationDatatableData>()

export function getConsultationDatatableColumns({ isLoading,  handleDetails }: Props) {
  
  return [
    columnHelper.accessor("pan",
        {
            id: "panId",
            header: "PAN",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("sequence",
        {
            id: "sequenceId",
            header: "Sequence",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("oneId",
        {
            id: "oneId",
            header: "ID",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("nberOfCommands",
        {
            id: "nberOfCommandsId",
            header: "Nbre commandes",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("nberOfSendings",
        {
            id: "nberOfSendingsId",
            header: "Nbre envois",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("executionDate",
        {
            id: "executionDateId",
            header: "Date execution",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("endDate",
        {
            id: "endDateId",
            header: "Date purge",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("status",
        {
            id: "statusId",
            header: "Statut",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    {props.getValue()}
                </Skeleton>)
            },
        }
    ),
    columnHelper.accessor("active",
        {
            id: "activeId",
            header: "Actif",
            cell: (props) => {
                return (<Skeleton isLoaded={!isLoading}>
                    <Checkbox checked={!!props.getValue()} readOnly></Checkbox>
                </Skeleton>)
            },
        }
    ),
    columnHelper.display(
        {
            id: "action",
            header: "",
            cell: props => {
                return (
                    <Skeleton isLoaded={!isLoading}>
                        <Center>
                        <CustomButton
                            size={'sm'}
                            onClick={() => handleDetails(props.row)}                            
                        >
                            Commande
                        </CustomButton>
                        {/* <CustomDataTableInfoBtn disabled={isLoading} onClick={() => displayDetails(props.row)} /> */}
                        </Center>
                    </Skeleton>
                );
            }
        }

    ),
  ];
}
